import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=c1ab7eda&scoped=true&"
import script from "./ResourceManage.vue?vue&type=script&lang=js&"
export * from "./ResourceManage.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/chunkUpload.css?vue&type=style&index=0&id=c1ab7eda&scoped=true&lang=css&"
import style1 from "../../../assets/css/resources.css?vue&type=style&index=1&id=c1ab7eda&scoped=true&lang=css&"
import style2 from "./ResourceManage.vue?vue&type=style&index=2&id=c1ab7eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ab7eda",
  null
  
)

export default component.exports